// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection/AccordionSection";
import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter";
import { accordionProductDetailsSectionProps } from "@store/Themes/common/props/accordionProductDetails";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type AccordionVariantOption = DataOption<AccordionSectionPresentationProps>;
export interface AccordionVariantOptionMapper {
    default: AccordionVariantOption;
    footer: AccordionVariantOption;
    productDetails: AccordionVariantOption;
}
export type AccordionVariantOptions = DataOptions<AccordionVariantOption> & AccordionVariantOptionMapper;
export type AccordionVariant = LiteralUnion<keyof AccordionVariantOptionMapper>;

export const accordionVariantOptions: AccordionVariantOptions = {
    default: { id: "default", displayName: "Default", isDefault: true },
    footer: { id: "footer", displayName: "Footer", value: accordionFooterSectionProps },
    productDetails: {
        id: "productDetails",
        displayName: "Product Details",
        value: accordionProductDetailsSectionProps,
    },
};

export type AccordionVariantFieldValue = AccordionVariant | undefined;
export interface AccordionVariantFieldOptions {
    isChildDefinition?: boolean;
}

export const getAccordionVariantFieldData = (
    value: AccordionVariantFieldValue,
    options?: AccordionVariantFieldOptions,
) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(accordionVariantOptions, value);
};

export const getAccordionVariantFieldDefinition = (name: string, options?: AccordionVariantFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(accordionVariantOptions),
        name,
        displayName: "Accordion Variant",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getAccordionVariantField = (name: string, options?: AccordionVariantFieldOptions) => {
    const parse = (value: AccordionVariantFieldValue) => getAccordionVariantFieldData(value, options);

    return {
        definition: getAccordionVariantFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getAccordionVariantField;
